/**
 * 【设置页】常量
 */
export const SETTING_TABS = {
  USER_SETTING: 'account',
  HOTEL_SETTING: 'hotel',
  OPERATE_LOG: 'oplog',
  TC_LOG: 'tcLog',
  LOCK_LOG: 'locklog',
  FEATURE_SETTING: 'feature',
  HELP_CENTER: 'help',
};

export const SETTING_TABS_LIST = [{
  name: '门店管理',
  id: SETTING_TABS.HOTEL_SETTING,
  act: '查看门店信息',
}, {
  name: '操作日志',
  id: SETTING_TABS.OPERATE_LOG,
  requireInnId: true,
  disabled: true,
  act: '查看操作日志',
}, {
  name: '物理门锁日志',
  id: SETTING_TABS.TC_LOG,
  requireInnId: true,
  disabled: true,
  act: '查看门锁日志',
},{
  name: '门锁日志',
  id: SETTING_TABS.LOCK_LOG,
  requireInnId: true,
  disabled: true,
  act: '查看门锁日志',
}, {
  name: '功能设置',
  cid: '设置-功能设置',
  id: SETTING_TABS.FEATURE_SETTING,
  requireInnId: true,
  disabled: true,
  act: '功能设置',
}, {
  name: '帮助中心',
  cid: '设置-帮助中心',
  id: SETTING_TABS.HELP_CENTER,
  requireInnId: true,
  disabled: true,
  act: '帮助中心',
}];

export const USER_TABS_LIST = [{
  name: '帐号信息',
  id: SETTING_TABS.USER_SETTING,
  act: '查看账号信息',
}];



// WEBPACK FOOTER //
// ./consts/settings.js